class AuthRequest {
  static login = {
    username: null,
    password: null,
    idtoken: null
  };

  static initiateEnrollment = {
    firstName: null,
    lastName: null,
    email: null,
    countryCode: null,
    country: null,
    phone: null,
    source: "WEB"
  };

  static completeEnrollment = {
    otp: null,
    password: null,
    confirmPassword: null,
    email: null
  };

  static changePassword = {
    oldPassword: null,
    password: null,
    passwordConfirmation: null,
    username: null,
    countryCode: null
  };

  static resendOtp = {
    username: null,
    countryCode: null
  };

  static initiatePasswordReset = {
    username: null,
    countryCode: null
  };

  static completePasswordReset = {
    username: null,
    countryCode: null,
    password: null,
    passwordConfirmation: null,
    otp: null
  };
  static userDetails = {};
  static googleSignUp = {
    idToken: null,
    countryCode: null,
    phone: null
  };
}

export default AuthRequest;
